export const Config = {
    baseFolder: '',
    apiRoot: 'https://rwa.normasoft.net/api/v1/',
    fakerEnabled: false,
    protectionOff: false,
    googleKey: 'AIzaSyBl2wI_4Ce4fb0GKnOMznGFx0Eq03VxtCw',
    mobileWidth: 1024
}